import { render } from "./UnassignedClientUsers.vue?vue&type=template&id=4a4e5d21&ts=true"
import script from "./UnassignedClientUsers.vue?vue&type=script&lang=ts"
export * from "./UnassignedClientUsers.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__